<template >
  <ul class="m-header__usps" aria-label="Unique selling points" v-if="props.usps && props.usps.length > 0">
    <li class="m-header__usp" v-for="usp of props.usps">
      <slot name="icon">
        <svg class="a-icon a-icon--usp">
          <use xlink:href="#check"></use>
        </svg>
      </slot>
      <span class="m-header__usps-text">{{ usp }}</span>
    </li>
  </ul>
</template>

<script setup lang="ts">

const props = defineProps({
  usps: {
    type: Array<string>,
    default: [],
  },
})

</script>
